import React from "react";
import TickIcon from "../../assets/icons/tick.svg2";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export default function TemplateDetail({
  Icon = TickIcon,
  label,
  value,
}: {
  Icon: any;
  label: string;
  value: string | React.ReactNode;
}) {
  return (
    <div className="d-flex align-items-center py-2">
      <div style={{ width: 25 }} className="me-2 flex-shrink-0">
        <Icon />
      </div>
      <h5 className="row align-items-start flex-grow-1 d-flex">
        <div className=" text-secondary text-nowrap">{label}: </div>
        <div className="text-black fw-bold text-break">
          <OverlayTrigger
            overlay={<Tooltip id={label + "" + value}>{value}</Tooltip>}
          >
            <div>{value}</div>
          </OverlayTrigger>
        </div>
      </h5>
    </div>
  );
}
